if (!customElements.get('moonou-bundle-builder')) {
  customElements.define(
    'moonou-bundle-builder',
    class MoonouBundleBuilder extends HTMLElement {
      constructor() {
        super();
        this.selections = new Map();
        this.addons = new Map();
        this.stepCount = parseInt(this.dataset.stepCount, 10) || 0;
      }

      connectedCallback() {
        this.bindElements();
        this.initAddons();
        this.attachEventListeners();
        this.updateActiveStep();
        this.updateProgress();
        this.updateTotal();
        this.updateCTA();
        this.updateDeliveryRange();
      }

      bindElements() {
        this.steps = this.querySelectorAll('.mbb__step');
        this.cards = this.querySelectorAll('.mbb__card');
        this.addonEls = this.querySelectorAll('.mbb__addon');

        /* Bottom bar elements */
        this.bar = this.querySelector('.mbb__bar');
        this.barToggle = this.querySelector('[data-bar-toggle]');
        this.progressFill = this.querySelector('[data-progress-fill]');
        this.barSelections = this.querySelectorAll('[data-bar-selection]');
        this.totalEl = this.querySelector('[data-total-price]');
        this.totalValue = this.querySelector('[data-total-value]');
        this.ctaButton = this.querySelector('[data-cta-button]');
        this.ctaTextEl = this.querySelector('[data-cta-text]');
        this.ctaPriceEl = this.querySelector('[data-bar-cta-price]');
        this.errorMessage = this.querySelector('[data-error-message]');

        this.ctaActiveText = this.dataset.ctaActive || 'In den Warenkorb';
        this.ctaIncompleteText = this.dataset.ctaIncomplete || 'Bitte alle Schritte abschließen';
        this.emptySelectionText = this.dataset.emptySelection || 'Noch nicht ausgewählt';

        /* Delivery elements */
        this.deliveryRange = this.querySelector('[data-delivery-range]');
        this.deliveryDaysMin = parseInt(this.dataset.deliveryMin, 10) || 20;
        this.deliveryDaysMax = parseInt(this.dataset.deliveryMax, 10) || 30;
      }

      initAddons() {
        var self = this;
        this.addonEls.forEach(function (el) {
          var idx = parseInt(el.dataset.addonIndex, 10);
          var variantId = el.dataset.variantId;
          if (!variantId) return; // skip addons without a product configured
          self.addons.set(idx, {
            el: el,
            variantId: variantId,
            quantity: parseInt(el.dataset.addonQty, 10) || 1,
            unitPrice: parseInt(el.dataset.addonPrice, 10) || 0,
            title: el.dataset.addonTitle || '',
            enabled: el.dataset.enabled === 'true'
          });
        });
      }

      attachEventListeners() {
        this.cards.forEach(function (card) {
          card.addEventListener('click', this.onCardClick.bind(this, card));
        }.bind(this));

        if (this.ctaButton) {
          this.ctaButton.addEventListener('click', this.onSubmit.bind(this));
        }

        if (this.barToggle) {
          this.barToggle.addEventListener('click', this.onToggleBar.bind(this));
        }

        var self = this;
        this.addonEls.forEach(function (el) {
          var toggle = el.querySelector('[data-addon-toggle]');
          if (!toggle) return;
          toggle.addEventListener('click', self.onAddonToggle.bind(self, el));
          toggle.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              self.onAddonToggle(el);
            }
          });
        });
      }

      onAddonToggle(el) {
        var idx = parseInt(el.dataset.addonIndex, 10);
        var addon = this.addons.get(idx);
        if (!addon) return;

        addon.enabled = !addon.enabled;
        el.setAttribute('data-enabled', addon.enabled ? 'true' : 'false');
        var row = el.querySelector('[data-addon-toggle]');
        if (row) row.setAttribute('aria-pressed', addon.enabled ? 'true' : 'false');

        this.updateTotal();
      }

      onCardClick(card) {
        var stepIndex = parseInt(card.dataset.step, 10);
        var variantId = card.dataset.variantId;
        var title = card.dataset.productTitle;
        var price = parseInt(card.dataset.productPrice, 10);
        var imageUrl = card.dataset.productImage || '';
        var wasSelected = card.getAttribute('data-selected') === 'true';

        // Deselect all cards in this step
        var stepCards = this.querySelectorAll('.mbb__card[data-step="' + stepIndex + '"]');
        stepCards.forEach(function (c) {
          c.setAttribute('data-selected', 'false');
        });

        if (wasSelected) {
          // Toggle OFF: remove from selections
          this.selections.delete(stepIndex);
        } else {
          // Select clicked card
          card.setAttribute('data-selected', 'true');
          this.selections.set(stepIndex, {
            variantId: variantId,
            title: title,
            price: price,
            imageUrl: imageUrl
          });
        }

        this.updateProgress();
        this.updateSelectionList();
        this.updateTotal();
        this.updateCTA();
        this.advanceActiveStep();
      }

      onToggleBar() {
        if (!this.bar) return;
        var expanded = this.bar.getAttribute('data-expanded') === 'true';
        this.bar.setAttribute('data-expanded', expanded ? 'false' : 'true');
      }

      updateActiveStep() {
        var activeIndex = -1;
        for (var i = 0; i < this.stepCount; i++) {
          if (!this.selections.has(i)) {
            activeIndex = i;
            break;
          }
        }

        this.steps.forEach(function (step, i) {
          step.setAttribute('data-active', i === activeIndex ? 'true' : 'false');
        });
      }

      advanceActiveStep() {
        var self = this;
        requestAnimationFrame(function () {
          self.updateActiveStep();
        });
      }

      updateProgress() {
        if (!this.progressFill) return;
        var pct = this.stepCount > 0
          ? Math.round((this.selections.size / this.stepCount) * 100)
          : 0;
        this.progressFill.style.setProperty('--progress', pct + '%');
      }

      updateSelectionList() {
        var self = this;
        this.barSelections.forEach(function (item) {
          var stepIndex = parseInt(item.dataset.barSelection, 10);
          var mediaEl = item.querySelector('[data-bar-media]');
          var valueEl = item.querySelector('[data-bar-value]');
          var priceEl = item.querySelector('[data-bar-price]');

          var sel = self.selections.get(stepIndex);
          if (sel) {
            item.setAttribute('data-filled', 'true');
            if (valueEl) valueEl.textContent = sel.title;
            if (priceEl) priceEl.textContent = self.formatMoney(sel.price);
            if (mediaEl) {
              if (sel.imageUrl) {
                mediaEl.innerHTML = '<img src="' + sel.imageUrl + '" alt="" loading="lazy">';
              } else {
                mediaEl.innerHTML = '';
              }
            }
          } else {
            item.setAttribute('data-filled', 'false');
            if (valueEl) valueEl.textContent = self.emptySelectionText;
            if (priceEl) priceEl.textContent = '';
            if (mediaEl) mediaEl.innerHTML = '';
          }
        });
      }

      updateTotal() {
        if (!this.totalEl || !this.totalValue) return;

        var sum = 0;
        this.selections.forEach(function (sel) {
          sum += sel.price;
        });
        this.addons.forEach(function (addon) {
          if (addon.enabled) sum += addon.unitPrice * addon.quantity;
        });

        if (sum === 0) {
          this.totalEl.hidden = true;
          if (this.ctaPriceEl) this.ctaPriceEl.textContent = '';
          return;
        }

        this.totalEl.hidden = false;
        var formatted = this.formatMoney(sum);
        this.totalValue.textContent = formatted;
        if (this.ctaPriceEl) this.ctaPriceEl.textContent = formatted;
      }

      formatMoney(cents) {
        if (window.Shopify && window.Shopify.formatMoney) {
          return Shopify.formatMoney(cents, window.theme && theme.moneyFormat || '{{amount_with_comma_separator}} \u20AC');
        }
        return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
      }

      updateCTA() {
        if (!this.ctaButton || !this.ctaTextEl) return;

        var allDone = this.selections.size === this.stepCount;
        this.ctaButton.disabled = !allDone;
        this.ctaTextEl.textContent = allDone ? this.ctaActiveText : this.ctaIncompleteText;
      }

      onSubmit() {
        if (this.selections.size < this.stepCount) return;
        if (this.ctaButton.hasAttribute('aria-disabled')) return;

        var items = [];
        this.selections.forEach(function (sel) {
          items.push({ id: parseInt(sel.variantId, 10), quantity: 1 });
        });
        this.addons.forEach(function (addon) {
          if (addon.enabled) {
            items.push({ id: parseInt(addon.variantId, 10), quantity: addon.quantity });
          }
        });

        // Page cart fallback
        if (document.body.classList.contains('template-cart') || (window.theme && theme.settings.cartType === 'page')) {
          theme.utils.postLink2(theme.routes.cart_add_url, {
            parameters: { items: items }
          });
          return;
        }

        this.ctaButton.setAttribute('aria-disabled', 'true');
        this.ctaButton.setAttribute('aria-busy', 'true');
        this.handleError();

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          })
        );

        var body = JSON.stringify({
          items: items,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });

        var self = this;

        fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: body
        })
          .then(function (response) { return response.json(); })
          .then(function (parsedState) {
            if (parsedState.status) {
              self.handleError(parsedState.description);
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: { errorMessage: parsedState.description }
              }));
              return;
            }

            return fetch(theme.routes.cart_url, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
            })
              .then(function (r) { return r.json(); })
              .then(function (cartJson) {
                cartJson['sections'] = parsedState['sections'];

                theme.pubsub.publish(
                  theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
                  { source: 'moonou-bundle-builder', cart: cartJson }
                );

                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: { product: parsedState }
                }));

                var cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) cartDrawer.show(self.ctaButton);
              });
          })
          .catch(function (err) {
            console.error('[MBB]', err);
          })
          .finally(function () {
            self.ctaButton.removeAttribute('aria-busy');
            self.ctaButton.removeAttribute('aria-disabled');
          });
      }

      addBusinessDays(startDate, numDays) {
        var date = new Date(startDate);
        var added = 0;
        while (added < numDays) {
          date.setDate(date.getDate() + 1);
          var day = date.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return date;
      }

      updateDeliveryRange() {
        if (!this.deliveryRange) return;
        var today = new Date();
        var minDate = this.addBusinessDays(today, this.deliveryDaysMin);
        var maxDate = this.addBusinessDays(today, this.deliveryDaysMax);
        var opts = { day: 'numeric', month: 'short' };
        var lang = document.documentElement.lang || 'de';
        this.deliveryRange.textContent =
          minDate.toLocaleDateString(lang, opts) + ' \u2013 ' + maxDate.toLocaleDateString(lang, opts);
      }

      handleError(msg) {
        if (!this.errorMessage) return;
        this.errorMessage.hidden = !msg;
        this.errorMessage.textContent = msg || '';
      }
    }
  );
}

/* Theme Editor Support */
document.addEventListener('shopify:block:select', function (e) {
  var builder = e.target.closest('moonou-bundle-builder');
  if (!builder) return;
  var step = e.target.closest('.mbb__step');
  if (step) {
    step.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
});
